import { Typography } from '@mui/material'
import { StyledPageTitle } from './CommonStyles'
import styled from '@emotion/styled'

export default function AboutUs() {
  const StyledText = styled(Typography)`
    font-family: GenYOGothic2TW;
    color: #515151;
    font-weight: normal;
    font-size: 24px;
    line-height: 36px;
  `
  return (
    <div>
      <Typography variant="h2">關於行創</Typography>
      <Typography variant="subtitle1" align="justify">
        行創有限公司成立於 2009 年，專注於物聯網 (IoT)
        設備聯網解決方案，致力於推動智慧製造與智慧管理的關鍵技術。憑藉深厚的技術實力與豐富的產業經驗，行創幫助企業將傳統設備與現代數據技術整合，實現生產流程數位化、智慧化，提升管理效率與企業競爭力。我們的解決方案涵蓋
        設備聯網、數據採集與分析、AI
        智慧決策、遠端監控與預警等領域，確保客戶能夠即時掌握設備狀態並優化生產流程。
      </Typography>
    </div>
  )
}
